/** Import react/libraries section **/
import React from 'react';

/** Import resources section **/
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import TextArea from 'textarea-autosize-reactjs';

/** Styles **/
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
    // height: '65px',
    // minHeight: '65px'
  },
  '&:hover': {
    backgroundColor: theme.palette.normal.main
  },
  focused: { backgroundColor: '#fff' }
}));

const styles = () => ({
  inputLabel: {
    fontSize: '12px',
    height: '12px'
  },
  input: {
    margin: 0,
    verticalAlign: 'center',
    backgroundColor: 'white',
    // height: '35px',
    placeholderTextColor: '#ced4da',
    padding: '10px 0',
    fontSize: '13px'
  }
});

export const MUITextArea = ({
  name,
  id,
  labelId,
  label,
  type = 'text',
  value,
  onChange,
  style,
  disabled,
  placeholder,
  color = 'secondary',
  styleText,
  disabledText,
  ...props
}) => {
  const classes = useStyles();
  const customClasses = styles();

  const handleOnChange = (e) => {
    const inputValue = e.target.value;

    const returnValue = inputValue
      ? type === 'number'
        ? parseFloat(inputValue)
        : inputValue
      : null;

    onChange({ id: id, name: name, value: returnValue });
  };

  return (
    <div id={'MUI_' + id} className={classes.root}>
      {label && (
        <InputLabel
          id={labelId ? labelId : label + '__InputLabel'}
          style={customClasses.inputLabel}
        >
          {label}
        </InputLabel>
      )}

      <TextArea
        autoComplete="new"
        id={id}
        type={type}
        name={name}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={handleOnChange}
        style={customClasses.input}
        {...props}
      />
    </div>
  );
};

export default MUITextArea;
